


















































































import { defineComponent } from '@nuxtjs/composition-api'
import { useMobile } from '~/composables/ui/useMobile'
import { CitationResult } from '~/types/product/productTypes'
import IconFaSolidCamera from '~icons/fa-solid/camera'
export default defineComponent({
  components: {
    IconFaSolidCamera,
  },
  name: 'CitationLine',
  props: {
    citationResult: {
      type: Object as () => CitationResult,
      required: true,
    },
  },
  setup() {
    const { isSmallMobile } = useMobile()
    const imageAlert = () => {
      alert('Opening extended view…”')
    }
    return { imageAlert, isSmallMobile }
  },
})
